module.exports = __webpack_public_path__ + "img/icon_bg_index_2.0.1.0_202503250930.png";